import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=2b9902ee&scoped=true&"
import script from "./Archived.vue?vue&type=script&lang=js&"
export * from "./Archived.vue?vue&type=script&lang=js&"
import style0 from "./Archived.vue?vue&type=style&index=0&id=2b9902ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9902ee",
  null
  
)

export default component.exports